import Radium from 'radium';
import React from 'react';
import { RouteHandler, State } from 'react-router';

import ReindexTypography from '../ui/_ReindexTypography';

const { rhythm } = ReindexTypography;
const styles = {
  container: {
    display: 'flex',
    maxWidth: 960,
    marginLeft: 'auto',
    marginRight: 'auto',
    '@media (max-width: 700px)': {
      flexDirection: 'column',
    },
  },
  content: {
    flex: 1,
  },
  sidebar: {
    width: `${100 * 3 / 12}%`,
    marginTop: 55,
    marginLeft: `${100 * 1 / 12}%`,
    '@media (max-width: 700px)': {
      width: 'auto',
      order: -1,
    },
  },
};

const pages = [
  {
    path: '/policies/terms-and-conditions/',
    title: 'Terms and Conditions',
  },
  {
    path: '/policies/privacy-policy/',
    title: 'Privacy Policy',
  },
  {
    path: '/policies/open-source/',
    title: 'Open Source',
  },
];

const PoliciesPage = React.createClass({
  mixins: [State],

  render() {
    const links = pages.map((child) =>
      <li
        key={child.path}
        style={{
          marginBottom: rhythm(1 / 2),
        }}>
        <a href={child.path}>
          {
            this.isActive(child.path) ?
              <strong>{child.title}</strong> :
              child.title
          }
        </a>
      </li>
    );
    return (
      <div style={styles.container}>
        <div style={styles.content}>
          <RouteHandler {...this.props} />
        </div>
        <div style={styles.sidebar}>
          <ul style={{ listStyle: 'none', margin: 0 }}>
            {links}
          </ul>
        </div>
      </div>
    );
  },
});

export default Radium(PoliciesPage);



/** WEBPACK FOOTER **
 ** ./policies/_template.jsx
 **/